import React, {Fragment, useContext, useRef} from 'react'
import { Dialog, Transition } from '@headlessui/react'
import {OrderContext} from "../../context/OrderContext";
import { BsPencil } from "react-icons/bs";
import {APIPostOrderLinkedMessaging} from "../../api/orders/OrdersMessaging";
import {APICreateContract} from "../../api/orders/OrdersContracts";
import { UserContext } from '../../context/UserContext';

export default function ContractTenderModal({data}) {
    const {user} = useContext(UserContext);
    const {order, getOrder, openContractTender, setOpenContractTender, saveOrder } = useContext(OrderContext);
    const cancelButtonRef = useRef(null);

    const signContract = async () => {
        const messageData = {
            ordersId : order?.id,
            linkId : order?.id,
            linkType : "progressUpdate",
            createdByUser : user?.id,
            createdByUserName : user?.name,
            createdByCompany : user?.companyId,
            createdByCompanyName : user?.companyId,
            message : "Auftrag vergeben an: "+data?.companyname ,
            orderCompany: order?.createdByCompany,
            contractedCompany: order?.contractedCompany,
            planId: order?.planId,
        }

        // create Contract
        await Promise.all([
            APICreateContract(data?.ordersId, data?.tenderId, data?.bid, data?.companyid, user),
            APIPostOrderLinkedMessaging({messageData, companyId: user?.companyId}),
            saveOrder("contracted", data?.ordersId)
        ]);
        await getOrder();
    }

    return (
        <Transition.Root show={openContractTender} as={Fragment}>
            <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={setOpenContractTender}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-8 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6  lg:max-w-2xl">
                                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                                    <div className="sm:flex sm:items-start">
                                        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                            <BsPencil  className="h-6 w-6 text-red-600" aria-hidden="true" />
                                        </div>
                                        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                            <Dialog.Title as="h3" className="text-lg  font-bold mb-4 mt-2 leading-6 text-gray-900">
                                                Auftrag an die "{data?.companyname}" vergeben.
                                            </Dialog.Title>
                                            <div className="mt-6">
                                                <p className="text-sm text-gray-600">
                                                    Sie können nun Ihren Auftrag an {data?.companyname} vergeben. Mit der Beauftragung endet die Angebotsabgabe.
                                                    Sollte die Vergabe extern über eine Vergabe-Plattform oder E-Mailverfahren vergeben worden sein, bleibt dieses von der Vergabe auf XPLANUNG24 unberührt.<br/><br/>
                                                    Mit Vergabe erhält die {data?.companyname}, vollständigen Zugriff auf den Auftrag und beginnt mit der Umsetzung dessen.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2  sm:gap-3">
                                    <button
                                        type="button"
                                        className="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:col-start-2"
                                        onClick={() => {
                                            signContract();
                                        }}
                                    >
                                        Auftrag vergeben
                                    </button>
                                    <button
                                        type="button"
                                        className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                                        onClick={() => setOpenContractTender(false)}
                                        ref={cancelButtonRef}
                                    >
                                        Schließen
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}
